// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1id9n","signatureBlock":"Footer_signatureBlock__1eBwp","signature":"Footer_signature__34oCa"};